import React from 'react';
import styled from 'styled-components';

const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';
import Button from '../../../../components/Button';
import ContainerModal from '../../../../components/ContainerModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
  }
`;

type ModalNineYearsDriveThruProps = {
  visible: boolean;
  onClickClose: () => void;
};
export const ModalNineYearsDriveThru: React.FC<ModalNineYearsDriveThruProps> = ({ visible, onClickClose }) => {
  return (
    <ContainerModal
      visible={visible}
      onClose={onClickClose}
      withoutCloseButton
      childrenFooter={
        <>
          <Button disabled={!visible} type="button" title="Fechar" onClick={onClickClose} />
        </>
      }
    >
      <Container>
        <img src={warningIcon} alt="warning" />
        <h3 className="title">Aviso importante!</h3>
        <p className="subtitle">
          Por motivos de segurança, a vacina da gripe via Drive-thru não é permitida para menores de 9 anos. Por favor,
          escolha outro tipo de atendimento.
        </p>
      </Container>
    </ContainerModal>
  );
};
